import { Check, MessageCircle } from "lucide-react";
import { Reveal, SectionTag } from "@/components/Reveal";
import { IMAGES, WHATSAPP_LINK } from "@/lib/site";

const DISCUSS = [
  "Hospital operational requirements",
  "Insurance & TPA coordination",
  "Cashless process support",
  "Hospital empanelment requirements",
  "Staff training",
  "Healthcare business development",
  "Healthcare networking opportunities",
];

export const HospitalOwners = () => (
  <section id="hospitals" className="relative overflow-hidden bg-white py-24 sm:py-32">
    <div className="pointer-events-none absolute -right-40 top-0 h-[420px] w-[420px] rounded-full bg-amber-500/5 blur-[120px]" />
    <div className="mx-auto grid max-w-7xl grid-cols-1 items-center gap-16 px-4 sm:px-6 lg:grid-cols-12 lg:px-8">
      <Reveal className="order-2 lg:order-1 lg:col-span-5">
        <div className="spotlight-frame relative">
          <div className="overflow-hidden rounded-[2rem] border border-[#0B3C5C]/15 shadow-2xl shadow-black/40">
            <img
              src={IMAGES.insuranceDesk}
              alt="Hospital insurance desk and documentation"
              className="aspect-[4/5] w-full object-cover transition-transform duration-700 hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#060D17]/70 via-transparent to-transparent" />
          </div>
          <div className="glass-panel absolute -right-3 top-8 rounded-2xl px-5 py-4 sm:-right-6">
            <p className="font-mono-x text-[10px] uppercase tracking-[0.25em] text-amber-500">For Owners</p>
            <p className="font-display mt-1 text-sm font-bold text-[#0B3C5C]">Directors & Management</p>
          </div>
        </div>
      </Reveal>

      <div className="order-1 lg:order-2 lg:col-span-7">
        <Reveal>
          <SectionTag index="05" label="For Hospital Owners & Directors" />
          <h2 className="font-display mt-6 text-2xl font-bold tracking-tight text-[#0B3C5C] sm:text-3xl lg:text-4xl">
            Your Hospital. Your Challenges. Our Healthcare Expertise.
          </h2>
          <p className="mt-6 max-w-2xl text-base leading-relaxed text-[#33586F]">
            Hospital management involves much more than clinical care. Insurance processes,
            cashless coordination, documentation, staff capabilities, business development and
            professional networking can all require structured attention.
          </p>
          <p className="mt-4 max-w-2xl text-base leading-relaxed text-[#4A6B82]">
            Healthcare Solutions aims to provide professional support across relevant
            healthcare-sector requirements.
          </p>
        </Reveal>

        <Reveal delay={0.12}>
          <p className="font-mono-x mt-10 text-[11px] uppercase tracking-[0.3em] text-[#4C8F2F]">We can discuss:</p>
          <ul className="mt-5 grid grid-cols-1 gap-3 sm:grid-cols-2">
            {DISCUSS.map((d) => (
              <li key={d} className="flex items-start gap-3 text-sm text-[#33586F]">
                <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-[#5FA832]/15">
                  <Check className="h-3 w-3 text-[#4C8F2F]" />
                </span>
                {d}
              </li>
            ))}
          </ul>
        </Reveal>

        <Reveal delay={0.2}>
          <div className="mt-10 flex flex-wrap gap-4">
            <a
              href="#enquiry"
              data-testid="hospital-cta-consultation"
              className="rounded-full bg-[#5FA832] px-8 py-4 text-sm font-bold text-white transition-all duration-300 hover:bg-[#4C8F2F] hover:shadow-xl hover:shadow-[#5FA832]/25"
            >
              Request Hospital Consultation
            </a>
            <a
              href={WHATSAPP_LINK}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="hospital-cta-whatsapp"
              className="inline-flex items-center gap-2 rounded-full border border-emerald-500/40 px-8 py-4 text-sm font-semibold text-emerald-600 transition-all duration-300 hover:border-emerald-400 hover:bg-emerald-500/10"
            >
              <MessageCircle className="h-4 w-4" />
              WhatsApp Our Team
            </a>
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
